import { useModel as _useModel, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ElSlider } from 'element-plus';
import { ref } from 'vue';

// Control value

export default /*@__PURE__*/_defineComponent({
  __name: 'Slider',
  props: {
    "modelValue": {},
    "modelModifiers": {},
  },
  emits: ["update:modelValue"],
  setup(__props) {

const value = _useModel<number>(__props, "modelValue");

// Generate marks to show on the slider
const marks = ref<Record<number, string>>({
    1: '1',
});

for (let i = 5; i <= 50; i += 5) {
    marks.value[i] = i.toString();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(ElSlider), {
    class: "slider",
    min: 1,
    max: 50,
    marks: marks.value,
    modelValue: value.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((value).value = $event))
  }, null, 8, ["marks", "modelValue"]))
}
}

})